export default {
  state: {
    visibility: false,
    map: {}
  },
  mutations: {
    INIT_EXPAND_MAP_DIALOG(state, payload) {
      state.map = payload
      state.visibility = true
    },

    RESET_EXPAND_MAP_DIALOG(state) {
      state.map = {}
      state.visibility = false
    }
  }
}
